import axios, { isAxiosError, } from 'axios';
import { updateTokens, logout } from 'store/actions/auth.actions';
import { API_METHODS } from 'config/constants';
let axiosClient;
class AxiosClient {
    constructor(props) {
        this._useAdminToken = false;
        this.subscribers = [];
        this.isAlreadyFetchingAccessToken = false;
        this.hasShownUnauthorizedAlert = false;
        this.onInterceptorsRequest = (config) => {
            const { authState = {} } = this._store.getState();
            const adminAccessToken = localStorage.getItem('.admin-access-token');
            const { accessToken = '' } = authState;
            config.headers['Accept'] = 'application/json';
            config.headers['Content-Type'] = 'application/json';
            config.headers['Access-Control-Allow-Origin'] = '*';
            if ((accessToken || adminAccessToken) && !config.headers.Authorization) {
                config.headers['Authorization'] = `Bearer ${this._useAdminToken ? adminAccessToken : accessToken}`;
            }
            return config;
        };
        this.onInterceptorsResponse = () => {
            /**
             * @todo: This is bad. Despite cutting down data.data calls, it's stripping all data from the
             * request, and confusing the types. {@link https://github.com/axios/axios/issues/1510}
             */
            const returnResponseData = (response) => {
                // Preserve the headers in the data object
                const responseData = response.data && typeof response.data === 'object'
                    ? response.data
                    : { data: response.data };
                responseData.headers = response.headers;
                return responseData;
            };
            const returnResponseError = async (error) => {
                var _a;
                const { response = {} } = error;
                const requestConfig = isAxiosError(error) ? error.config : undefined;
                const isAuthorizedRequestFailed = response.status === 401 && response.config.headers.Authorization;
                const { authState } = this._store.getState();
                if (!(requestConfig === null || requestConfig === void 0 ? void 0 : requestConfig.disabledErrorAlert) &&
                    this._setErrorMessageAlert &&
                    !this.hasShownUnauthorizedAlert &&
                    !!authState.isAuth) {
                    const errors = Array.isArray(response.data.errors)
                        ? response.data.errors.map((error) => { var _a; return (_a = error.message) !== null && _a !== void 0 ? _a : ''; })
                        : [
                            'Something went wrong processing the request. Please try again later.',
                        ];
                    const errorMsg = {
                        title: (_a = response.data.message) !== null && _a !== void 0 ? _a : 'Unexpected error occurred',
                        text: errors,
                    };
                    this._setErrorMessageAlert(errorMsg);
                    this.hasShownUnauthorizedAlert = true;
                }
                if (!isAuthorizedRequestFailed) {
                    return Object.assign({ statusCode: response.status }, response.data);
                }
                this.refreshToken();
                const { config: originalRequest = {} } = error;
                return new Promise((resolve, reject) => {
                    this.addSubscriber((newAccessToken) => {
                        if (!newAccessToken) {
                            return reject({ error: 'refreshTokenError' });
                        }
                        originalRequest.headers.Authorization = 'Bearer ' + newAccessToken;
                        // originalRequest.baseURL = '';
                        resolve(this._client.request(originalRequest));
                    });
                });
            };
            return [returnResponseData, returnResponseError];
        };
        Object.keys(props).forEach((propName) => {
            // @ts-ignore
            this[`_${propName}`] = props[propName];
        });
        this._API_URL = props.API_URL;
        this._API_URL_FOR_LISTS = props.API_URL_FOR_LISTS;
        this._setErrorMessageAlert = props.setErrorMessageAlert;
        const localAxios = axios.create({
            baseURL: this._API_URL,
        });
        const altAxios = axios.create({
            baseURL: this._API_URL_FOR_LISTS,
        });
        const refreshAxios = axios.create({
            baseURL: this._API_URL,
        });
        localAxios.interceptors.request.use(this.onInterceptorsRequest);
        altAxios.interceptors.request.use(this.onInterceptorsRequest);
        localAxios.interceptors.response.use(...this.onInterceptorsResponse());
        altAxios.interceptors.response.use(...this.onInterceptorsResponse());
        this._client = localAxios;
        this._altClient = altAxios;
        this._refreshClient = refreshAxios;
    }
    onAccessTokenFetched(accessToken) {
        this.subscribers = this.subscribers.filter((callback) => callback(accessToken));
        this.hasShownUnauthorizedAlert = false;
    }
    onAccessTokenError() {
        this.subscribers = this.subscribers.filter((callback) => callback(''));
    }
    addSubscriber(callback) {
        this.subscribers.push(callback);
    }
    setWithAdminToken(on) {
        this._useAdminToken = on;
    }
    refreshToken() {
        if (!this.isAlreadyFetchingAccessToken) {
            this.isAlreadyFetchingAccessToken = true;
            const { authState = {} } = this._store.getState();
            const { refreshToken = '' } = authState;
            this._refreshClient
                .put(`${API_METHODS.AUTH_REFRESH}?token=${refreshToken}`)
                .then((refreshResponse) => {
                const { data = {} } = refreshResponse.data;
                const { accessToken: newAccessToken } = data;
                this.isAlreadyFetchingAccessToken = false;
                this.onAccessTokenFetched(newAccessToken);
                this._store.dispatch(updateTokens(data));
            }, (refreshError) => {
                const { response: refreshErrorResponse = {} } = refreshError;
                if (refreshErrorResponse.status === 401 ||
                    refreshErrorResponse.status === 403) {
                    this.isAlreadyFetchingAccessToken = false;
                    this.onAccessTokenError();
                    this._store.dispatch(logout());
                }
                else {
                    setTimeout(() => this.refreshToken(), 1500);
                }
            });
        }
    }
    getAxios() {
        return this._client;
    }
    getListAxios() {
        return this._altClient;
    }
}
/*
 * Initialization
 * @param {object} props - some properties
 */
function init(props) {
    axiosClient = new AxiosClient(props);
}
/*
 * Will return new instance of Axios
 * @returns {object}
 */
function getAxios() {
    return axiosClient.getAxios();
}
function getAxiosWrapper() {
    return axiosClient;
}
function getListAxios() {
    return axiosClient.getListAxios();
}
export { init, getAxios, getListAxios, getAxiosWrapper };
